module.exports = __webpack_public_path__ + "static/media/get-an-offer-ipswich.25e1981d.png";